import { ColorRing } from "react-loader-spinner";

export default function SavingIndicator() {
    return (
        <div className="d-flex justify-content-center align-items-center loading-bg">
            <ColorRing
                visible={true}
                height="80"
                width="80"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            />
        </div>
    )
}